export function getFilenameFromUrl(url: string): string | undefined {
  const matches = url.match(/[^/\\&?#]+\.\w{3,4}(?=([?&#].*$|$))/);
  return matches ? matches[0] : undefined;
}

export function getExtensionFromUrl(url: string): string | undefined {
  const filename = getFilenameFromUrl(url);
  return filename ? filename.split('.')[1] : undefined;
}
